// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a7eed77","455":"71aa8cdb","977":"e5f32a85"}[chunkId] + ".chunk.js";
};